import ManageStorage from "src/shared/global/manageStorage";
import authApiConfig from "./authApiConfig"

const ServiceAuth = {
    async authUserGuest(body) {
        return await authApiConfig.post("/invitado/token", body)
    }, 
    async loginUser (body) {
        return await authApiConfig.post("/usuario/login", body);
    },
    async verifyTokenRegistered() {
        return await authApiConfig.get("/usuario/registrado/verificar-token", {
            headers: {
                'Authorization': `Bearer ${ManageStorage.getValueFromStorage("tokenUser")}`
            }
        })
    }
}

export default ServiceAuth;